// prettier-ignore
// @ts-ignore
import { ChartWrapper, InterfaceRenderParams } from "@pureprofile/access-dashboards-react-components";
import * as React from "react";
import { renderChartToDom } from "../helpers/renderChartToDom";

export const renderSingleChart = (
  id: string | HTMLElement,
  options: InterfaceRenderParams
) =>
  renderChartToDom(
    <ChartWrapper
      data={options.data}
      type={options.type}
      options={options.options}
      id={id.toString()}
    />,
    id
  );
